export default __webpack_public_path__ + "static/media/check-info.9f0a574a.svg";